'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CircularProgress = require('./CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CircularProgress2.default;


//////////////////
// WEBPACK FOOTER
// ../~/material-ui/CircularProgress/index.js
// module id = ../node_modules/material-ui/CircularProgress/index.js
// module chunks = 0